<template>
  <div :style="width ? { width: width } : {}">
    <label :for="label">{{ label }}</label>
    <input
      :id="label"
      type="text"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'DataInput',
  props: {
    label: String,
    width: String,
    value: [String, Number, Object]
  }
}
</script>

<style scoped>
div {
  display: inline-block;
  padding-right: 5px;
}
label {
  font-size: 80%;
  display: block;
}
input {
  width: 100%;
}
</style>
